var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellerNetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 43,
    viewBox: "0 0 26 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 29.5C1 33.9183 4.58172 37.5 9 37.5H17C21.4183 37.5 25 33.9183 25 29.5C25 25.0817 21.4183 21.5 17 21.5H9C4.58172 21.5 1 17.9183 1 13.5C1 9.08172 4.58172 5.5 9 5.5H17C21.4183 5.5 25 9.08172 25 13.5M13 1.5V41.5",
    stroke: "#091DF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerNetIcon);
export default __webpack_public_path__ + "static/media/seller-net-icon.e0cb1cf516f5ca259f026926ec41b98d.svg";
export { ForwardRef as ReactComponent };